import type { QueryStatus } from "@tanstack/vue-query";
import { computed, type ComputedRef, type Ref } from "vue";

export function useCombineQueryStatus(
  stati: Array<Ref<QueryStatus>>,
): ComputedRef<QueryStatus> {
  const status = computed((): QueryStatus => {
    const s = stati.map((s) => s.value);

    if (s.includes("error")) return "error";
    if (s.includes("pending")) return "pending";

    return "success";
  });

  return status;
}
